import { cn } from '@/lib/cn';
import { Tooltip, TooltipContent, TooltipTrigger } from '@heidi/design-system/tooltip';
import { type ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

// `<span>` trigger anchor because `<NavItem>` doesn't forward refs — same
// pattern as the offline-gated branch in `nav-item.tsx`.
export const OpenSessionListTooltip = ({
  enabled,
  children,
}: {
  enabled: boolean;
  children: ReactNode;
}) => {
  if (!enabled) return <>{children}</>;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        {/* In label-icons mode, shrink the trigger's box to just the icon row
            (44px) so Radix centers the tooltip on the icon rather than the
            icon+label group. `mb-5` reserves the 20px label-row height that
            `overflow-visible` paints outside the box, keeping the flex
            container's per-item footprint at 64px (matches
            `sidebarMenuButtonLabelIconsVariants` — icon row 44px + label row).
            Gated on the label-icons variant so other sidebar modes (if the
            variant ever changes) keep natural sizing. */}
        <span
          className={cn(
            'block',
            'group-data-[collapsible=label-icons]/sidebar:h-11',
            'group-data-[collapsible=label-icons]/sidebar:mb-5',
            'group-data-[collapsible=label-icons]/sidebar:overflow-visible'
          )}
        >
          {children}
        </span>
      </TooltipTrigger>
      <TooltipContent
        side="right"
        align="center"
        // The trigger is the full-width row, with the icon tile ~10px inside;
        // -6 gives the tile the footer rail's 4px tooltip gap.
        sideOffset={-6}
        // `px-2 py-1` matches `SidebarMenuButton`'s built-in tooltip padding;
        // we set it by hand because we wrap `<NavItem>` externally.
        className="px-2 py-1"
      >
        <FormattedMessage defaultMessage="Open session list" id="jyMLJTWjwa" />
      </TooltipContent>
    </Tooltip>
  );
};
